import React, { FC } from 'react'
import Button from '../../../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { FormProps } from '../../../../Pages/Onboarding/types'

const IndividualReverseSolicitationForm: FC<FormProps> = props => {
  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }

  const {
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    configData,
  } = useForm(props.fetchedData, config, submitForm)

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.IndividualAccount.ReverseSolicitationForm.title')}
        </FormTitle>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default IndividualReverseSolicitationForm
